/**
 * BaseTools
 *
 * */
import CornerstoneMZYL from "./cornerstoneMZYL"
import MPR from "@/utils/MPR/MPR.class"
import store from "@/store"
import { ElMessage } from 'element-plus'
class CornerstoneToolsMZYL {
  constructor() {
    this._rootVue = null
    this._init()
  }

  static getInstance() {
    if (!CornerstoneToolsMZYL.instance) {
      CornerstoneToolsMZYL.instance = new CornerstoneToolsMZYL()
      return CornerstoneToolsMZYL.instance
    }
    return CornerstoneToolsMZYL.instance
  }

  get rootVue() {
    return this._rootVue
  }

  _init() {
    cornerstoneTools.init({
      showSVGCursors: true,
      globalToolSyncEnabled: true
    })
  }

  EnabledAllTools() {
    // Enable all tools we want to use with this element
    const WwwcTool = cornerstoneTools.WwwcTool
    const LengthTool = cornerstoneTools.LengthTool
    const PanTool = cornerstoneTools.PanTool
    const ZoomTouchPinchTool = cornerstoneTools.ZoomTouchPinchTool
    const ZoomTool = cornerstoneTools.ZoomTool
    const DragProbeTool = cornerstoneTools.DragProbeTool
    const EllipticalRoiTool = cornerstoneTools.EllipticalRoiTool
    const RectangleRoiTool = cornerstoneTools.RectangleRoiTool
    const FreehandRoiTool = cornerstoneTools.FreehandRoiTool
    const AngleTool = cornerstoneTools.AngleTool
    const MagnifyTool = cornerstoneTools.MagnifyTool
    const StackScrollMouseWheelTool = cornerstoneTools.StackScrollMouseWheelTool
    const StackScrollTool = cornerstoneTools.StackScrollTool
    const ScaleOverlayTool = cornerstoneTools.ScaleOverlayTool
    const OverlayTool = cornerstoneTools.OverlayTool;
    const ArrowAnnotateTool = cornerstoneTools.ArrowAnnotateTool;
    const LineMarkerTool = cornerstoneTools.LineMarkerTool;
    const TextMarkerTool = cornerstoneTools.TextMarkerTool;
    const ProbeTool = cornerstoneTools.ProbeTool;
    //   const OrientationMarkersTool = cornerstoneTools.OrientationMarkersTool
    cornerstoneTools.addTool(MagnifyTool)
    cornerstoneTools.addTool(AngleTool)
    cornerstoneTools.addTool(WwwcTool)
    cornerstoneTools.addTool(LengthTool)
    cornerstoneTools.addTool(PanTool)
    cornerstoneTools.addTool(ZoomTouchPinchTool)
    cornerstoneTools.addTool(ZoomTool)
    cornerstoneTools.addTool(DragProbeTool)
    cornerstoneTools.addTool(EllipticalRoiTool)
    cornerstoneTools.addTool(RectangleRoiTool)
    cornerstoneTools.addTool(FreehandRoiTool)
    cornerstoneTools.addTool(StackScrollTool)
    cornerstoneTools.addTool(StackScrollMouseWheelTool)
    cornerstoneTools.addTool(cornerstoneTools.ReferenceLinesTool)
    cornerstoneTools.addTool(cornerstoneTools.CrosshairsTool)
    cornerstoneTools.addTool(ScaleOverlayTool)
    cornerstoneTools.addTool(OverlayTool)
    cornerstoneTools.addTool(ArrowAnnotateTool)
    cornerstoneTools.addTool(LineMarkerTool);
    cornerstoneTools.addTool(ProbeTool);
    const configuration = {
      markers: ['F5', 'F4', 'F3', 'F2', 'F1'],
      current: 'F5',
      ascending: true,
      loop: true,
    }
    cornerstoneTools.addTool(TextMarkerTool,{configuration})

    //   cornerstoneTools.addTool(OrientationMarkersTool)
    // cornerstoneTools.setToolEnabled("Length")
    // cornerstoneTools.setToolEnabled("Pan")
    // cornerstoneTools.setToolEnabled("Magnify")
    // cornerstoneTools.setToolEnabled("Angle")
    // cornerstoneTools.setToolEnabled("RectangleRoi")
    // cornerstoneTools.setToolEnabled("Wwwc")
    // cornerstoneTools.setToolEnabled("ZoomTouchPinch")
    // cornerstoneTools.setToolEnabled("DragProbe")
    // cornerstoneTools.setToolEnabled("EllipticalRoi")
    // cornerstoneTools.setToolEnabled("FreehandRoi")
    // cornerstoneTools.setToolEnabled("StackScrollMouseWheel")
    // cornerstoneTools.setToolEnabled("StackScroll")
    // cornerstoneTools.setToolEnabled('Overlay');
    // cornerstoneTools.setToolEnabled('ScaleOverlay');
  }

  setToolActive(eventType, option) {
    cornerstoneTools.setToolActive(eventType, option)
  }

  setToolActiveWwwc() {
    sessionStorage.setItem('wwccActive', true);
    cornerstoneTools.setToolActive("Wwwc", {
      mouseButtonMask: 1
    })
  }

  setToolActiveWwwcPreset(value) {
    CornerstoneMZYL.WwwcPreset(value)
  }

  setToolActiveType(tool) {
    if (tool === "mpr") {
      const seriesList = store.getters.imageBrowsing[CornerstoneMZYL.seriesIndex];
      if(seriesList){
        const { percentage ,getDcmFilePath } = seriesList
        if(percentage < getDcmFilePath.length){
          ElMessage({
            message: "dcm文件正在下载中，请稍等！",
            type:'warning'
          });
          return
        }
      }
      
      store.dispatch("updateUseMPR", true)
      window.__once = false
      MPR.seriesNumber = CornerstoneMZYL.seriesIndex
      store.dispatch("setViewportList", [
        {
          style: {
            width: "100%",
            height: "50%"
          },
        },
        {
          style: {
            width: "50%",
            height: "50%"
          }
        },
        {
          style: {
            width: "50%",
            height: "50%"
          }
        }
      ])
      this._rootVue.$nextTick(() => {
        const viewporTargetSub = CornerstoneMZYL.getDomArray("viewportItem")
        viewporTargetSub.forEach((ele) => {
          cornerstone.disable(ele)
          cornerstone.enable(ele, {
            renderer: "webgl"
          })
          //删除绑定监听事件
          CornerstoneMZYL._removeEventListener(ele)
          //添加绑定监听事件
          CornerstoneMZYL._addEventListener(ele)
        })

        MPR.axialSeriesDom = viewporTargetSub[0]
        MPR.coronalSeriesDom = viewporTargetSub[1]
        MPR.sagittalSeriesDom = viewporTargetSub[2]
        MPR.OriginalSeriesData = store.getters.imageBrowsing[CornerstoneMZYL.seriesIndex] || [];
        MPR.setAxialMprUrl();
      })

      // 设置布局
      return
    }
    if (tool === "Clear") {
      const { viewportActive } = CornerstoneMZYL

      const enabledElement2 = cornerstone.getEnabledElement(viewportActive)
      if (!enabledElement2 || !enabledElement2.image) {
        return
      }

      const { toolState } =
        cornerstoneTools.globalImageIdSpecificToolStateManager
      if (
        !toolState ||
        Object.prototype.hasOwnProperty.call(
          toolState,
          enabledElement2.image.imageId
        ) === false
      ) {
        return
      }
      cornerstoneTools.globalImageIdSpecificToolStateManager.clearImageIdToolState(
        enabledElement2.image.imageId
      )
      cornerstone.updateImage(viewportActive)
      return
    }

    // 反色
    if (tool === "invert") {
      const { viewportActive } = CornerstoneMZYL
      const viewport = cornerstone.getViewport(viewportActive)
      viewport.invert = !viewport.invert
      cornerstone.setViewport(viewportActive, viewport)
      return
    }
    // 重置
    if (tool === "reset") {
      this.reset()
      return
    }
    // 播放
    if (tool === "playClip") {
      cornerstoneTools.setToolActive("StackScroll", {
        mouseButtonMask: 1
      })
      const { viewportActive } = CornerstoneMZYL
      cornerstoneTools.playClip(viewportActive, 4)
      return
    }
     // 反转
     if (tool == "flipViewportHorizontal" || tool == "flipViewportVertical") {
      let type = "hflip";
      if (tool == "flipViewportVertical") {
        type = "vflip";
      }
      let viewport = cornerstone.getViewport(CornerstoneMZYL.viewportActive);
      viewport[type] = !viewport[type];
      cornerstone.setViewport(CornerstoneMZYL.viewportActive, viewport);
      return;
    }
    // 旋转
    if (tool == "rotateViewport+") {
      let viewport = cornerstone.getViewport(CornerstoneMZYL.viewportActive);
      viewport.rotation += 90;
      cornerstone.setViewport(CornerstoneMZYL.viewportActive, viewport);
      return;
    }
    if (tool == "rotateViewport-") {
      let viewport = cornerstone.getViewport(CornerstoneMZYL.viewportActive);
      viewport.rotation -= 90;
      cornerstone.setViewport(CornerstoneMZYL.viewportActive, viewport);
      return;
    }
    // 截图
    if(tool == "jietu"){
      // 获取
      const image = cornerstone.getImage(CornerstoneMZYL.viewportActive)
      let byteArray = image.data.byteArray;
      var dataSet = dicomParser.parseDicom(byteArray /*, options */);
      let InstanceUID = dataSet.string('x00080018');
      cornerstoneTools.SaveAs(CornerstoneMZYL.viewportActive, `${InstanceUID}.png`)
      return;
    }
    // 截图
    if(tool == "downDCM"){
      const image = cornerstone.getImage(CornerstoneMZYL.viewportActive)
      window.location.href = image.sharedCacheKey;
      return;
    }
    cornerstoneTools.setToolActive(tool, { mouseButtonMask: 1 })
  }

  rotateViewport() {
    CornerstoneMZYL.rotateViewport()
  }

  scaleViewport(scale) {
    CornerstoneMZYL.scaleViewport(scale)
  }

  reset() {
    CornerstoneMZYL.reset()
  }

  mixin(rootVue) {
    this._rootVue = rootVue
  }
}

export default CornerstoneToolsMZYL.getInstance()
